<template>
  <div>
    <div class="review-input-form" v-if="isEditing">
      <div class="form-group">
        <label>
          <p>ユーザー名</p>
          <input type="text" v-model="review.user_name" />
        </label>
        <label>
          <p>タイトル</p>
          <input type="text" v-model="review.title" />
        </label>
        <label>
          <p>スコア</p>
          <input type="number" min="1" max="5" v-model="review.score" />
        </label>
        <!-- quill-editor を label で囲ってしまうとデフォルトで太字になるため for を使う -->
        <label for="review-editor-comment">
          <p>コメント</p>
        </label>
        <quill-editor id="review-editor-comment" v-model="review.comment" />
        <div class="form-group__footer">
          <a class="btn-green" @click="onEndEdit()">追加</a>
          <a class="btn-green" @click="onDeleteInput()">削除</a>
        </div>
      </div>
    </div>
    <div class="review-input-preview input-preview" v-else>
      <div class="review">
        <div class="review__head">
          <time>{{ formattedDate }}</time>
          <p>{{ review.user_name }}</p>
          <div class="review__score">
            <p class="review__score-star">
              {{ stars }}
            </p>
            <p>({{ review.score }})</p>
          </div>
        </div>

        <h4 class="review__title">
          {{ review.title }}
        </h4>
        <div
          class="review__body"
          v-html="review.comment.replace(/\n/g, '<br/>')"
        />
      </div>
      <footer-menu
        :onDeleteInput="onDeleteInput"
        :onBeginEdit="onBeginEdit"
        :onPullUp="onPullUp"
        :onPullDown="onPullDown"
        :index="index"
      />
    </div>
  </div>
</template>

<script>
import footerMenu from '../input-footer-menu.vue';

const SCORE_MAX = 5;

export default {
  name: 'ReviewEditor',
  components: {
    'footer-menu': footerMenu,
  },
  props: {
    value: Object,
    index: Number,
    id: String,
  },
  data() {
    return {
      isEditing: false,
      review: {
        user_name: this.value.review.user_name,
        score: this.value.review.score,
        title: this.value.review.title,
        comment: this.value.review.comment,
        created_at: this.value.review.created_at
          ? new Date(this.value.review.created_at)
          : new Date(),
      },
    };
  },
  computed: {
    stars() {
      return '★'.repeat(this.review.score).padEnd(SCORE_MAX, '☆');
    },
    formattedDate() {
      const d = this.review.created_at;
      return `${d.getFullYear()}/${
        d.getMonth() + 1
      }/${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    },
    bodyJSON() {
      return {
        value: {
          review_id: this.value.review_id ? this.value.review_id : null,
          review: {
            user_name: this.review.user_name,
            score: this.review.score,
            title: this.review.title,
            comment: this.review.comment,
          },
        },
        action: 'review',
        id: this.id,
      };
    },
    editorOptions() {
      return {
        modules: {
          table: true,
          toolbar,
        },
      };
    },
  },
  methods: {
    onBeginEdit() {
      this.isEditing = true;
    },
    onEndEdit() {
      this.review.score = Math.min(Math.max(this.review.score, 0), SCORE_MAX);

      if (this.review.user_name.length === 0) {
        alert('ユーザー名を入力してください');
        return false;
      }
      if (this.review.title.length === 0) {
        alert('タイトルを入力してください');
        return false;
      }
      if (this.review.comment.length === 0) {
        alert('コメントを入力してください');
        return false;
      }
      this.isEditing = false;
    },
    onDeleteInput() {
      bus.$emit('delete-input', this.index);
    },
    onPullUp() {
      bus.$emit('pull-up-item', this.index);
    },
    onPullDown() {
      bus.$emit('pull-down-item', this.index);
    },
  },
};
</script>

<style lang="scss" scoped>
.review-input-form {
  background-color: #eee;
  position: relative;
  padding: 15px 15px 1px;
  margin: 0 0 10px;

  h2 {
    font-size: 14px;
    margin: 0 0 10px;
  }
}

.form-group {
  &__item {
    &:nth-child(n + 2) {
      margin-top: 8px;
    }
  }

  &__footer {
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}

.ql-editor {
  font-size: 15px;
}

.review {
  border: 1px solid lightgrey;
  border-radius: 4px;
  padding: 12px;
  font-size: 14px;

  &__head {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__score {
    display: flex;
    align-items: center;
    gap: 4px;
  }

  &__score-star {
    color: #fab704;
  }

  &__title {
    margin-top: 12px;
    font-size: 20px;
    padding-bottom: 8px;
    border-bottom: 1px solid lightgray;
  }

  &__body {
    margin-top: 8px;
    white-space: pre-wrap;
  }
}
</style>
